<template>
   <svg name="padlock" viewBox="0 0 11 14" aria-hidden="true" focusable="false">
      <path
         fill-rule="evenodd"
         clip-rule="evenodd"
         d="M7.55063 3.58928V5.6399H3.44938V3.58928C3.44938 2.4524 4.36312 1.53865 5.5 1.53865C6.63688 1.53865 7.55063 2.4524 7.55063 3.58928ZM10.2812 13.8318H0.71875V5.62928H2.08938V3.7699C2.08938 1.9849 3.375 0.359278 5.14937 0.178653C7.18937 -0.0232224 8.92125 1.57053 8.92125 3.57865V5.62928H10.2919V13.8212L10.2812 13.8318Z"
      />
   </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
